import { render, staticRenderFns } from "./CollapseVcDemo.vue?vue&type=template&id=bc5cef08&scoped=true&"
import script from "./CollapseVcDemo.vue?vue&type=script&lang=js&"
export * from "./CollapseVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./CollapseVcDemo.vue?vue&type=style&index=0&id=bc5cef08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5cef08",
  null
  
)

export default component.exports